import React, { createRef, useEffect, useState } from 'react';
import { Button, Card, Col, Drawer, Form, Input, Row, Spin, Table } from 'antd';
import PageTitle from 'shared_components/page_title';
import Dropdown from 'modules/main/settings/shared/dropdown';
import {
    fetchModuleReports,
    fetchReportParameters,
    fetchSections,
    generateDataAnalysisReport,
	printDataAnalysisReport
} from 'services/settings/reports';
import ReportParametersPanel from 'modules/main/data_analysis/reports/reportParameterPanel';
import ViewReport from 'modules/main/data_analysis/reports/viewReport';

import { Document, Page, pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function Reports() {
    const formRef = createRef();
    const [selectedModule, setSelectedModule] = useState([]);
    const [moduleSections, setModuleSections] = useState([]);
    const [sectionReports, setSectionReports] = useState([]);
    const [reportParams, setReportParams] = useState([]);
    const [reportTitle, setReportTitle] = useState('');
    const [dateRangeInput, setDateRangeInput] = useState(false);
    const [paramPanel, setParamPanel] = useState(false);
    const [rangeValue, setRangeValue] = useState();
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [base64Response, setBase64Response] = useState('');
	const [printResponse, setPrintResponse] = useState('');

    const columns = [
        {
            title: 'REPORT NAME',
            dataIndex: 'reporttitle',
        },
    ];

    const getData = async () => {
        const getSections = await fetchSections();
        const sections = getSections.map((items, index) => {
            const options = {
                ...items,
                label: items.sectionName,
                value: items.sectionName,
            };
            return options;
        });
        // sections lists
        const sectionOptions = [
            { label: 'MISCELLANEOUS', value: 'MISCELLANEOUS', sectionName: 'MISCELLANEOUS' },
            ...sections,
        ];
        setModuleSections(sectionOptions);
    };

    useEffect(() => {
        getData();
    }, []);

    const handleModuleOnChange = async e => {
        const selectedModSection = moduleSections.filter(sec => sec.sectionName === e);

        setSelectedModule(selectedModSection);
        setReportTitle('');
        setParamPanel(false);

        const getModuleReports = await fetchModuleReports(e.toLowerCase());
        console.log('getModuleReports', getModuleReports);
        setSectionReports(getModuleReports.records);
    };

    const onClickTableRow = async e => {
        const reportParamValue = `${selectedModule[0].sectionName}/${e.reportname}`;
        setReportTitle(e.reporttitle.toUpperCase());

        const getReportParam = await fetchReportParameters(reportParamValue);
        const reportParameters = getReportParam.records.parameters;
        setReportParams(reportParameters);

        // check date range
        const startDate = reportParameters.filter(items => items.key === 'startdate');
        const endDate = reportParameters.filter(items => items.key === 'enddate');
        console.log('startDate', startDate);
        console.log('endDate', endDate);
        console.log('reportParameters', reportParameters);
        if (startDate.length > 0 && endDate.length > 0) {
            const rangeDateValue = {
                startDefaultValue: startDate[0].defaultvalue,
                startEnable: startDate[0].enable,
                startKey: startDate[0].key,
                startLabel: startDate[0].label,
                startType: startDate[0].type,
                endDefaultValue: endDate[0].defaultvalue,
                endEnable: endDate[0].enable,
                endKey: endDate[0].key,
                endLabel: endDate[0].label,
                endType: endDate[0].type,
            };
            // @ts-ignore
            setRangeValue(rangeDateValue);

            const filterParams = reportParameters.filter(
                items => items.key !== 'startdate' && items.key !== 'enddate',
            );
            setReportParams(filterParams);
            setDateRangeInput(true);
        } else {
            setDateRangeInput(false);
        }

        setParamPanel(true);
    };

    // Format dates to YYYY-MM-DD
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const handleOnView = async formValues => {
        const moduleName = selectedModule[0].sectionName;

        // Parse dates
        const startDate = new Date(formValues.dateRange[0]);
        const endDate = new Date(formValues.dateRange[1])
        console.log("🚀 ~ handleOnView ~ endDate:", endDate)

        const payload = {
            mode: 'export',
            parameters: [
                {
                    startdate: formatDate(startDate),
                    enddate: formatDate(endDate),
                },
            ],
        };

        setLoading(true);
        try {
            const printPreview = await generateDataAnalysisReport(moduleName, payload);
            const newBaseSixtyFour = printPreview.records[0].pdf;
            setBase64Response(newBaseSixtyFour);
			setPrintResponse(printPreview.records[0]);
            showDrawer();
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
        setBase64Response('');
    };

    return (
        <div>
            <ViewReport 
				title={reportTitle} 
				onClose={onClose} 
				open={open} 
				base64Response={base64Response} 
				section={selectedModule}
				printResponse={printResponse}
			/>
            <Row justify="center">
                <PageTitle pageTitle="REPORTS" />
            </Row>
            <Form onFinish={handleOnView} layout="vertical" ref={formRef}>
                <Row justify="center">
                    <Dropdown
                        placeholder="Select Section"
                        content={moduleSections}
                        onChange={handleModuleOnChange}
                        // loading={isInitializing}
                        value={selectedModule}
                    />
                </Row>
                <div className="space-y-sm"></div>
                <Row gutter={10}>
                    <Col style={{ width: '60%' }}>
                        <Table
                            style={{ textTransform: 'uppercase' }}
                            dataSource={sectionReports}
                            columns={columns}
                            pagination={false}
                            onRow={record => {
                                return {
                                    onClick: () => {
                                        onClickTableRow(record);
                                    },
                                };
                            }}
                        />
                    </Col>
                    <Col style={{ width: '40%' }}>
                        <Card title={reportTitle}>
                            {paramPanel ? (
                                <div>
                                    <ReportParametersPanel
                                        dateRangeInput={dateRangeInput}
                                        dateRangeValue={rangeValue}
                                        reportParams={reportParams}
                                        section={selectedModule}
                                    />
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        shape="round"
                                        style={{ width: 120, float: 'right' }}
                                    >
                                        {loading ? <Spin /> : 'VIEW'}
                                    </Button>
                                </div>
                            ) : (
                                <></>
                            )}
                        </Card>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}
